import gql from 'graphql-tag'

export default gql`
  fragment marketplaceCheckout on MarketplaceCheckout {
    id
    preferredFulfilmentType
    fulfilmentPreferences {
      delivery {
        suburb {
          name
          postcode
        }
      }
      pickup {
        centre {
          slug
          title
        }
      }
    }
    parcels {
      id
      fulfilmentType
      items {
        ...cartItem
      }
      availableFulfilmentOptions {
        id
        type: fulfilmentType
        cost
        provider
        fulfilmentDayRange {
          min
          max
        }
        label
      }
      selectedFulfilmentOption {
        id
        type: fulfilmentType
        cost
        provider
        fulfilmentDayRange {
          min
          max
        }
        label
      }
    }
    unavailableItems {
      ...cartItem
    }
    total
    currency
    payment {
      id
      clientSecret
      paymentMethodId
      cardType
      expYear
      expMonth
      last4
    }
    billingAddress {
      firstName
      lastName
      email
      phone
      address1
      suburb
      state
      stateCode
      postCode
      countryCode
    }
    shippingAddress {
      firstName
      lastName
      email
      phone
      address1
      suburb
      state
      stateCode
      postCode
      countryCode
    }
  }

  fragment cartItem on MarketplaceCartItem {
    id
    sku
    variantGroupCode
    name
    image {
      url
      description
    }
    listPrice
    discountPrice
    quantity
    optionValues {
      id
      optionId
      displayName
      value
    }
    shop {
      id
      name
    }
    brand
    category {
      path {
        code
        title
      }
    }
    variant {
      quantity
    }
  }
`
